// extracted by mini-css-extract-plugin
export default {"star":"style_star__YYkkI","readonly":"style_readonly__6unEn"};